<template>
  <v-layout
      row
      :style="maxWidth"
  >
    <v-flex
        class="ml-3"
        :style="maxWidth"
    >
      <breadcrumbs
          :items="breadcrumbsItems"
      ></breadcrumbs>
      <v-card class="mt-4" outlined>
        <v-col cols="6" v-if="tab !== 'sms'">
          <v-dialog
              ref="dialog"
              v-model="datepicker"
              :return-value.sync="daterange"
              persistent
              width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  v-model="dateRangeText"
                  label="Pick a date"
                  prepend-icon="event"
                  readonly
                  v-bind="attrs"
                  v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="daterange" scrollable range>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="datepicker = false">Cancel</v-btn>
              <v-btn text color="primary" @click="$refs.dialog.save(daterange)">OK</v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
        <v-card>
          <v-tabs
              v-model="tab"
              background-color="#EBEFFD"
              centered
              show-arrows
              icons-and-text
          >
            <v-tabs-slider></v-tabs-slider>
            <v-tab href="#queue">
              Queue Report
            </v-tab>
            <v-tab href="#served">
              Served Report
            </v-tab>
            <v-tab href="#consolidate">
              Consolidate Report
            </v-tab>
            <v-tab href="#sms">
              SMS Report
            </v-tab>
            <v-tabs-items v-model="tab">
              <v-tab-item
                  :key="1"
                  :value="'queue'"
              >
                <v-card-title>
                  Queues Report
                </v-card-title>
                <v-row>
                  <v-col cols="6" class="ma-2">
                    <v-text-field
                        v-model="searchQueue"
                        append-icon="mdi-magnify"
                        label="Search"
                        hide-details
                        class="ma-1"
                        outlined
                        dense
                        autocomplete="off"
                    ></v-text-field>
                  </v-col>
                  <v-col class="ma-2 text-right">
                    <vue-excel-xlsx
                        :data="queueData"
                        :columns="queueHeaders"
                        :filename="exportFilename('queue')"
                        :sheetname="'sheet1'"
                    >
                      <v-btn class="primary ma-1">
                        Export
                      </v-btn>
                    </vue-excel-xlsx>
                  </v-col>
                </v-row>
                <v-card
                    max-height="400"
                >
                  <v-data-table
                      :headers="queueHeaders"
                      :items="queueData"
                      :search="searchQueue"
                      dense
                      :items-per-page="30"
                      :fixed-header="true"
                      height="400"
                  >
                  </v-data-table>
                </v-card>
              </v-tab-item>
              <v-tab-item
                  :key="2"
                  :value="'served'"
              >
                <v-card-title>
                  Served Report
                </v-card-title>
                <v-row>
                  <v-col cols="6" class="ma-2">
                    <v-text-field
                        v-model="searchServed"
                        append-icon="mdi-magnify"
                        label="Search"
                        hide-details
                        class="ma-1"
                        outlined
                        dense
                        autocomplete="off"
                    ></v-text-field>
                  </v-col>
                  <v-col class="ma-2">
                    <vue-excel-xlsx
                        :data="servedData"
                        :columns="servedHeaders"
                        :filename="exportFilename('served')"
                        :sheetname="'sheet1'"
                    >
                      <v-btn class="primary ma-1">
                        Export
                      </v-btn>
                    </vue-excel-xlsx>
                  </v-col>
                </v-row>
                <v-card
                    max-height="400"
                >
                  <v-data-table
                      :headers="servedHeaders"
                      :items="servedData"
                      :search="searchServed"
                      dense
                      class="display-3 font-weight-medium"
                      :items-per-page="30"
                      :fixed-header="true"
                      height="400"
                  >
                  </v-data-table>
                </v-card>
              </v-tab-item>
              <v-tab-item
                  :key="3"
                  :value="'consolidate'"
              >
                <v-card-title>
                  Consolidate Report
                </v-card-title>
                <v-row>
                  <v-col cols="6" class="ma-2">
                    <v-text-field
                        v-model="searchConsolidate"
                        append-icon="mdi-magnify"
                        label="Search"
                        hide-details
                        class="ma-1"
                        outlined
                        dense
                        autocomplete="off"
                    ></v-text-field>
                  </v-col>
                  <v-col class="ma-2">
                    <vue-excel-xlsx
                        :data="consolidateData"
                        :columns="consolidateHeaders"
                        :filename="exportFilename('consolidate')"
                        :sheetname="'sheet1'"
                    >
                      <v-btn class="primary ma-1">
                        Export
                      </v-btn>
                    </vue-excel-xlsx>
                  </v-col>
                </v-row>
                <v-card
                    max-height="400"
                >
                  <v-data-table
                      :headers="consolidateHeaders"
                      :items="consolidateData"
                      :search="searchConsolidate"
                      dense
                      class="display-3 font-weight-medium"
                      :items-per-page="30"
                      :fixed-header="true"
                      height="400"
                  >
                  </v-data-table>
                </v-card>
              </v-tab-item>
              <v-tab-item
                  :key="4"
                  :value="'sms'"
              >
                <sms-statistic
                    :groups="myGroup"
                    :outlets="myOutlet"
                ></sms-statistic>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-card>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from 'axios'

export default {
  name: 'outlet-reports',
  props: ['group', 'outlet'],
  data: () => ({
    myGroup: [],
    myOutlet: [],
    tab: null,
    queueData: [],
    servedData: [],
    consolidateData: [],
    searchQueue: null,
    searchServed: null,
    searchConsolidate: null,
    daterange: [],
    datepicker: false,
    breadcrumbsItems: [],
  }),
  computed: {
    queueHeaders() {
      return [
        {
          text: 'Type',
          align: 'start',
          value: 'queue_type',
          label: 'Type',
          field: 'queue_type',
        },
        {
          text: 'Q No.',
          value: 'q_no',
          label: 'Q No.',
          field: 'q_no',
        },
        {
          text: 'Customer',
          value: 'customer',
          label: 'Customer',
          field: 'customer',
        },
        {
          text: this.remarksHeader,
          value: 'remarks',
          label: this.remarksHeader,
          field: 'remarks',
        },
        {
          text: 'Phone',
          value: 'phone_number',
          label: 'Phone',
          field: 'phone_number',
        },
        {
          text: 'Email',
          value: 'email',
          label: 'Email',
          field: 'email',
        },
        {
          text: 'Arrived',
          value: 'arrived_at',
          label: 'Arrived',
          field: 'arrived_at',
        },
        {
          text: 'Notify at',
          value: 'called_at',
          label: 'Notify at',
          field: 'called_at',
        },
        {
          text: 'Serving',
          value: 'serving_at',
          label: 'Serving',
          field: 'serving_at',
        },
        {
          text: 'Served',
          value: 'served_at',
          label: 'Served',
          field: 'served_at',
        },
        {
          text: 'Cancel',
          value: 'cancelled_at',
          label: 'Cancel',
          field: 'cancelled_at',
        },
        {
          text: 'Missed',
          value: 'missed_at',
          label: 'Missed',
          field: 'missed_at',
        },
        {
          text: 'Queue',
          value: 'queue_name',
          label: 'Queue',
          field: 'queue_name',
        },
        {
          text: 'Service',
          value: 'service_name',
          label: 'Service',
          field: 'service_name',
        },
        {
          text: 'Served By',
          value: 'served_by',
          label: 'Served By',
          field: 'served_by',
        },
      ]
    },
    servedHeaders() {
      return [
        {
          text: 'Served By',
          align: 'start',
          value: 'served_by',
          label: 'Served By',
          field: 'served_by',
        },
        {
          text: 'Queue',
          value: 'queue_name',
          label: 'Queue',
          field: 'queue_name',
        },
        {
          text: 'Service',
          value: 'service_name',
          label: 'Service',
          field: 'service_name',
        },
        {
          text: 'Served Pax',
          value: 'served_pax',
          label: 'Served Pax',
          field: 'served_pax',
        },
        {
          text: 'Average Time(mins)',
          value: 'average_time',
          label: 'Average Time(mins)',
          field: 'average_time',
        },
      ]
    },
    consolidateHeaders() {
      return [
        {
          text: 'Queue',
          align: 'start',
          value: 'queue_name',
          label: 'Queue',
          field: 'queue_name',
        },
        {
          text: 'Served Pax',
          value: 'served_pax',
          label: 'Served Pax',
          field: 'served_pax',
        },
        {
          text: 'Average Time',
          value: 'average_time',
          label: 'Average Time',
          field: 'average_time',
        },
        {
          text: 'Cancel',
          value: 'cancel_count',
          label: 'Cancel',
          field: 'cancel_count',
        },
      ]
    },
    dateRangeText() {
      return this.daterange.join(' ~ ')
    },
    remarksHeader() {
      return this.outlet.onsite_remarks && this.outlet.onsite_remarks_label ? this.outlet.onsite_remarks_label : 'Remarks';
    },
    maxWidth() {
      return {
        maxWidth: window.outerWidth + 'px'
      }
    },
  },
  watch: {
    daterange(val) {
      axios.post('/api/outletReports', {
        daterange: val,
        outlet_id: this.outlet.id
      }).then(response => {
        this.queueData = response.data.queueData
        this.servedData = response.data.servedData
        this.consolidateData = response.data.consolidateData
      })
    }
  },
  methods: {
    exportFilename(type) {
      let dateRange = this.daterange.join(' ~ ')
      if (type === 'queue') return 'Queue Report ' + dateRange
      if (type === 'served') return 'Served Report ' + dateRange
      if (type === 'consolidate') return 'Consolidate Report ' + dateRange
    }
  },
  beforeMount() {
    this.myOutlet.push(this.outlet)
    this.myGroup.push(this.group)
    this.breadcrumbsItems = [
      {
        disabled: false,
        href: '/',
        link: true,
        text: 'Home',
      },
      {
        disabled: false,
        href: '/outlet/' + this.outlet.id + '/edit',
        link: true,
        text: this.outlet.name,
      },
      {
        disabled: true,
        href: '#',
        link: true,
        text: 'Reports',
      },
    ];
  }

}
</script>

<style>
.v-data-table-header th {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Outlets/Report.vue